module.exports = __webpack_public_path__ + "img/product_101.8696fcd.svg";